"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiptModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _definitions = require("@ppay/definitions");
var _ui = require("../../ui");
var _interfaces = require("../../../interfaces");
var _DateTime = require("../DateTime");
var _Type = require("../Type");
var _AmountData = require("./AmountData");
var _ValueWhenTransacted = require("./ValueWhenTransacted");
var _Crypto = require("./Crypto");
var _Exchange = require("./Exchange");
var _Item = require("./Item");
var _CryptoInvoice = require("./CryptoInvoice");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRight = function arrowRight(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.00016 0.333984L8.06016 1.27398L11.1135 4.33398H0.333496V5.66732H11.1135L8.0535 8.72732L9.00016 9.66732L13.6668 5.00065L9.00016 0.333984Z",
    fill: "#3139CE"
  }));
};
arrowRight.defaultProps = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 20px;\n"])));
var StatusTitle = (0, _styledComponents.default)(_ui.P)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 0;\n"])), function (_ref) {
  var color = _ref.color,
    theme = _ref.theme;
  return theme.colors[color];
});
var Footer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var AllTransaction = (0, _styledComponents.default)(_ui.SmallMedium)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  text-align: center;\n  margin-top: 20px;\n  cursor: pointer;\n  width: 100%;\n  ", " {\n    margin-left: 4px;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, _ui.Svg);
var ReceiptModal = function ReceiptModal(_ref3) {
  var _transaction$hash, _transaction$paidAmou;
  var isOpen = _ref3.isOpen,
    toggle = _ref3.toggle,
    transaction = _ref3.transaction,
    onRowClick = _ref3.onRowClick,
    statusDotColor = _ref3.statusDotColor,
    showViewAll = _ref3.showViewAll;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransaction', 'libTransactionsTable']),
    t = _useTranslation.t;
  if (!transaction) return null;
  var isFiat = !!_definitions.FIAT_TICKERS.includes(transaction.ticker);
  var isCrypto = (_transaction$hash = transaction.hash) !== null && _transaction$hash !== void 0 ? _transaction$hash : !isFiat && transaction.type === _interfaces.TransactionType.WITHDRAWAL && !transaction.betweenAccounts;
  var isExchange = transaction.target;
  var isCryptoInvoice = transaction.paidAmount;
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: isOpen,
    toggle: toggle
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    className: "pb-2",
    onClick: toggle
  }, /*#__PURE__*/_react.default.createElement(_Type.Type, {
    betweenAccounts: transaction.betweenAccounts,
    internal: transaction.internal,
    type: transaction.type,
    fiat: isFiat,
    invoiceId: transaction.invoiceId,
    overPaid: transaction.isOverPaid,
    paidAmount: (_transaction$paidAmou = transaction.paidAmount) === null || _transaction$paidAmou === void 0 ? void 0 : _transaction$paidAmou.value,
    fullyPaid: transaction.isFullyPaid
  })), /*#__PURE__*/_react.default.createElement(ModalBody, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.id')
  }, transaction.id), transaction.invoiceId && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.invoice')
  }, transaction.invoiceId), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.status')
  }, /*#__PURE__*/_react.default.createElement(StatusTitle, {
    color: statusDotColor[transaction.status]
  }, t("status.".concat(transaction.status)))), transaction.failReason ? /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t("receipt.failReason")
  }, t("failReason.".concat(transaction.failReason))) : null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.kind')
  }, t("libTransaction:type.".concat(transaction.type))), isCrypto && /*#__PURE__*/_react.default.createElement(_Crypto.Crypto, {
    transaction: transaction
  }), isFiat && transaction.type === _interfaces.TransactionType.WITHDRAWAL && !transaction.betweenAccounts && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.to')
  }, transaction.to), isExchange && /*#__PURE__*/_react.default.createElement(_Exchange.Exchange, {
    transaction: transaction
  }), isCryptoInvoice && /*#__PURE__*/_react.default.createElement(_CryptoInvoice.CryptoInvoice, {
    transaction: transaction
  }), !isExchange && !isCryptoInvoice && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.currency')
  }, transaction.ticker), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.amount')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.amount.value,
    convertedValue: transaction.amount.converted,
    ticker: transaction.ticker
  }))), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.fee')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.fee.value,
    convertedValue: transaction.fee.converted,
    ticker: transaction.ticker
  })), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.transacted')
  }, /*#__PURE__*/_react.default.createElement(_ValueWhenTransacted.ValueWhenTransacted, {
    price: transaction.transacted.price,
    ticker: transaction.ticker
  })), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.time')
  }, /*#__PURE__*/_react.default.createElement(_DateTime.DateTime, {
    millis: transaction.time
  })), transaction.compliance && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.riskScore')
  }, transaction.compliance.riskScore * 100, "%"), transaction.compliance.url && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.complianceReport')
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    href: transaction.compliance.url
  }, t('receipt.download'), " "))), !showViewAll && /*#__PURE__*/_react.default.createElement(Footer, null, /*#__PURE__*/_react.default.createElement(_ui.SeparativeLine, null), /*#__PURE__*/_react.default.createElement(AllTransaction, {
    onClick: function onClick() {
      return onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(transaction.id);
    }
  }, t('receipt.allTransactions'), /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    as: arrowRight
  })))));
};
exports.ReceiptModal = ReceiptModal;